import { apiGet, apiDelete, ApiCallbacks } from '../apiClient';

export interface HealthResponse {
  status?: string;
  [key: string]: unknown;
}

export async function checkHealth(callbacks: ApiCallbacks<HealthResponse>): Promise<void> {
  const base = process.env.REACT_APP_ADMIN_API_BASE ?? '';
  await apiGet<HealthResponse>(`${base}/health`, callbacks, true, true);
}

export async function clearCache(callbacks: ApiCallbacks<void>): Promise<void> {
  const base = process.env.REACT_APP_ADMIN_API_BASE ?? '';
  await apiDelete<void>(`${base}/admin/cache`, callbacks, true);
}
